export function formatDate(date, fmt) {
  if (!date) {
    return "";
  }
  if (!(date instanceof Date)) {
    date = createDate(date);
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  let o = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + "";
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : padLeftZero(str)
      );
    }
  }
  return fmt;
}

function padLeftZero(str) {
  return ("00" + str).substr(str.length);
}

// 兼容ios时间
export function createDate(sd) {
  if (typeof sd === "string") {
    return new Date(sd.replace(/-/g, "/"));
  } else if (typeof sd === "number") {
    return new Date(sd);
  } else if (sd instanceof Date) {
    return sd;
  }
  return new Date();
}

// 时间戳转换为日期格式
export function timestampToTime(timestamp) {
  if (timestamp && timestamp.toString().indexOf("-") > -1) {
    return timestamp;
  }
  if (!timestamp) {
    return "";
  }

  timestamp = Number(timestamp);
  var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  // var Y = date.getFullYear() + "-";
  var M =
    date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1;
  var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate() + " ";
  // var h = date.getHours() + ":";
  // var m = date.getMinutes() + ":";
  // var s = date.getSeconds();
  return M + "/" + D;
}
